// extracted by mini-css-extract-plugin
module.exports = {"card":"partners-card_card__s6azj","svg":"partners-card_svg__wnE0Y"};